import { FC } from "react";
import { observer } from "mobx-react";
import { FullScreenLayout } from "@/components-v2/FullScreenLayout";
import { useAppBar } from "@/appBar/useAppBar";
import { Language } from "@/i18n/languages";
import { useLanguage, useUserPrefs } from "@/stores/RootStoreContext";
import { resolveTheme } from "@/theme/themeDomain";
import { PortfolioType, usePortfolio } from "@/portfolio/portfolioDomain";

const HelpCenter: FC<{
  portfolioId?: string;
  isPortfolioPage?: boolean;
  portfolioType: PortfolioType;
}> = observer(({ portfolioId, isPortfolioPage, portfolioType }) => {
  const { portfolio } = usePortfolio({
    activeHeader: "help-center",
    portfolioId,
    portfolioType,
  });
  const appBar = useAppBar({
    isPortfolioPage,
    selectedPortfolioOption: portfolio,
    portfolioHeader: "help-center",
  });
  const lang = useLanguage();
  const adjustedLang = lang === Language.SV ? Language.NO : lang;
  const userPrefs = useUserPrefs();
  const theme = resolveTheme(
    userPrefs.theme,
    window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false,
  );
  const helpUrl = `https://docs.dcompany.no/${adjustedLang}?embed=1${
    theme === "dark" ? "&theme=dark" : ""
  }`;
  return (
    <FullScreenLayout
      appBar={appBar}
      disableAppBarShadow
      centerPanelContainerProps={{ className: "relative" }}
      centerPanel={
        <iframe
          src={helpUrl}
          style={{ position: "absolute", height: "100%", width: "100%" }}
          height="100%"
          width="100%"
        />
      }
    />
  );
});
export default HelpCenter;
